import { Application, Controller } from '@hotwired/stimulus';
import { FormFieldsController } from '../form-fields/form-fields.stimulus';

export class KeypadController extends Controller {
    static targetsKeys = ['keypad', 'output'] as const;
    static targets = [...this.targetsKeys];

    /**
     * Register the controller in the given application
     */
    static register(application: Application) {
        application.register('keypad', this);
    }

    /**
     * Wrapper containing the keypad
     */
    declare readonly keypadTarget: HTMLElement;

    declare readonly keypadTargets: HTMLElement[];

    /**
     * The element that should output the keypad input.
     */
    declare readonly outputTarget: HTMLElement;

    /**
     * Check for existence of an output target element
     */
    declare readonly hasOutputTarget: boolean;

    /**
     * Sets the given element as the output of the pressed keypad values
     */
    static addAsOuputElement(element: HTMLElement) {
        element.setAttribute('data-keypad-target', 'output');
    }

    /**
     * Removes the given element as the output of the pressed keypad values
     */
    static removeAsOutputElement(elements: HTMLElement | HTMLElement[]) {
        if (elements instanceof HTMLElement) {
            elements.removeAttribute('data-keypad-target');
        } else {
            elements.forEach(element => element.removeAttribute('data-keypad-target'));
        }
    }

    /**
     * Tells you wheter the given element has an active keypad controller attached.
     * Helpful to handle some situations differently when a keypad is involved.
     */
    static isKeypadConnected(element: HTMLElement | Element) {
        return element.hasAttribute('data-controller') && element.getAttribute('data-controller').includes('keypad');
    }

    connect() {
        console.log('Connect keypad controller...');
    }

    toggleVirtualKeyboard(newState?: boolean) {
        this.keypadTarget.hidden = newState !== undefined ? newState : !this.keypadTarget.hidden;
    }

    press({ params: { key } }: Event & { params: { key: number } }) {
        if (this.hasOutputTarget) {
            if (this.outputTarget instanceof HTMLInputElement) {
                FormFieldsController.rememberCurrentFieldValue(this.outputTarget);
                this.outputTarget.value = this.outputTarget.value + key.toString();

                FormFieldsController.handleNumberFieldChanges(this.outputTarget);
            }
        } else {
            console.error(`Missing data-keypad-target="output"`);
        }

        this.dispatch('keypress', {
            detail: { value: key },
            target: this.outputTarget
        });
    }
}
